import SettingsPage from './SettingsPage';
import UploadImageButton from './UploadImageButton';

export const components = {
  SettingsPage,
  UploadImageButton,
};
